import React from "react";

export default (props) => <ul className="nav nav-tabs">{props.children}</ul>;



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/tab/TabsHeader.jsx